import { getCustomQueries } from '@/helpers/queryHelper';
import {
  ADD_ANNOUNCEMENT_INSTRUCTOR,
  ADD_ANNOUNCEMENT_INSTRUCTOR_FAILED,
  ADD_ANNOUNCEMENT_INSTRUCTOR_SUCCEEDED,
  ADD_ASSESSMENT,
  ADD_ASSESSMENT_ANSWER,
  ADD_ASSESSMENT_ANSWER_COMMENT,
  ADD_ASSESSMENT_ANSWER_COMMENT_FAILED,
  ADD_ASSESSMENT_ANSWER_COMMENT_SUCCEEDED,
  ADD_ASSESSMENT_ANSWER_FAILED,
  ADD_ASSESSMENT_ANSWER_SUCCEEDED,
  ADD_ASSESSMENT_FAILED,
  ADD_ASSESSMENT_QUESTION_COMMENT,
  ADD_ASSESSMENT_QUESTION_COMMENT_FAILED,
  ADD_ASSESSMENT_QUESTION_COMMENT_SUCCEEDED,
  ADD_ASSESSMENT_SUCCEEDED,
  ADD_MEETING_VIDEO,
  ADD_MEETING_VIDEO_FAILED,
  ADD_MEETING_VIDEO_SUCCEEDED,
  ADD_ROOM_DISCUSSION,
  ADD_ROOM_DISCUSSION_COMMENT,
  ADD_ROOM_DISCUSSION_COMMENT_FAILED,
  ADD_ROOM_DISCUSSION_COMMENT_REPLIES,
  ADD_ROOM_DISCUSSION_COMMENT_REPLIES_FAILED,
  ADD_ROOM_DISCUSSION_COMMENT_REPLIES_SUCCEEDED,
  ADD_ROOM_DISCUSSION_COMMENT_SUCCEEDED,
  ADD_ROOM_DISCUSSION_FAILED,
  ADD_ROOM_DISCUSSION_SUCCEEDED,
  ADD_ROOM_INSTRUCTOR,
  ADD_ROOM_INSTRUCTOR_FAILED,
  ADD_ROOM_INSTRUCTOR_SUCCEEDED,
  ADD_ROOM_MEETINGS_INSTRUCTOR,
  ADD_ROOM_MEETINGS_INSTRUCTOR_FAILED,
  ADD_ROOM_MEETINGS_INSTRUCTOR_SUCCEEDED,
  CLEAR_COMMENT_DISCCUSION_DATA,
  CLEAR_COMMENT_REPLY_DATA,
  CLEAR_ROOM_DATA,
  CLEAR_ROOM_DATA_TO_INITIAL,
  CLEAR_ROOM_ERROR,
  CLEAR_ROOM_QUERY,
  DELETE_ANNOUNCEMENT_INSTRUCTOR,
  DELETE_ANNOUNCEMENT_INSTRUCTOR_FAILED,
  DELETE_ANNOUNCEMENT_INSTRUCTOR_SUCCEEDED,
  DELETE_ASSESSMENT,
  DELETE_ASSESSMENT_ANSWER,
  DELETE_ASSESSMENT_ANSWER_COMMENT,
  DELETE_ASSESSMENT_ANSWER_COMMENT_FAILED,
  DELETE_ASSESSMENT_ANSWER_COMMENT_SUCCEEDED,
  DELETE_ASSESSMENT_ANSWER_FAILED,
  DELETE_ASSESSMENT_ANSWER_SUCCEEDED,
  DELETE_ASSESSMENT_FAILED,
  DELETE_ASSESSMENT_QUESTION_COMMENT,
  DELETE_ASSESSMENT_QUESTION_COMMENT_FAILED,
  DELETE_ASSESSMENT_QUESTION_COMMENT_SUCCEEDED,
  DELETE_ASSESSMENT_SUCCEEDED,
  DELETE_ROOM_DISCUSSION,
  DELETE_ROOM_DISCUSSION_COMMENT,
  DELETE_ROOM_DISCUSSION_COMMENT_FAILED,
  DELETE_ROOM_DISCUSSION_COMMENT_REPLIES,
  DELETE_ROOM_DISCUSSION_COMMENT_REPLIES_FAILED,
  DELETE_ROOM_DISCUSSION_COMMENT_REPLIES_SUCCEEDED,
  DELETE_ROOM_DISCUSSION_COMMENT_SUCCEEDED,
  DELETE_ROOM_DISCUSSION_FAILED,
  DELETE_ROOM_DISCUSSION_SUCCEEDED,
  DELETE_ROOM_INSTRUCTOR,
  DELETE_ROOM_INSTRUCTOR_FAILED,
  DELETE_ROOM_INSTRUCTOR_SUCCEEDED,
  DELETE_ROOM_MEETINGS_INSTRUCTOR,
  DELETE_ROOM_MEETINGS_INSTRUCTOR_FAILED,
  DELETE_ROOM_MEETINGS_INSTRUCTOR_SUCCEEDED,
  EDIT_ANNOUNCEMENT_INSTRUCTOR,
  EDIT_ANNOUNCEMENT_INSTRUCTOR_FAILED,
  EDIT_ANNOUNCEMENT_INSTRUCTOR_SUCCEEDED,
  EDIT_ASSESSMENT,
  EDIT_ASSESSMENT_ANSWER,
  EDIT_ASSESSMENT_ANSWER_COMMENT,
  EDIT_ASSESSMENT_ANSWER_COMMENT_FAILED,
  EDIT_ASSESSMENT_ANSWER_COMMENT_SUCCEEDED,
  EDIT_ASSESSMENT_ANSWER_FAILED,
  EDIT_ASSESSMENT_ANSWER_SUCCEEDED,
  EDIT_ASSESSMENT_FAILED,
  EDIT_ASSESSMENT_QUESTION_COMMENT,
  EDIT_ASSESSMENT_QUESTION_COMMENT_FAILED,
  EDIT_ASSESSMENT_QUESTION_COMMENT_SUCCEEDED,
  EDIT_ASSESSMENT_SUCCEEDED,
  EDIT_ROOM_DISCUSSION,
  EDIT_ROOM_DISCUSSION_COMMENT,
  EDIT_ROOM_DISCUSSION_COMMENT_FAILED,
  EDIT_ROOM_DISCUSSION_COMMENT_REPLIES,
  EDIT_ROOM_DISCUSSION_COMMENT_REPLIES_FAILED,
  EDIT_ROOM_DISCUSSION_COMMENT_REPLIES_SUCCEEDED,
  EDIT_ROOM_DISCUSSION_COMMENT_SUCCEEDED,
  EDIT_ROOM_DISCUSSION_FAILED,
  EDIT_ROOM_DISCUSSION_SUCCEEDED,
  EDIT_ROOM_INSTRUCTOR,
  EDIT_ROOM_INSTRUCTOR_FAILED,
  EDIT_ROOM_INSTRUCTOR_SUCCEEDED,
  EDIT_ROOM_MEETINGS_INSTRUCTOR,
  EDIT_ROOM_MEETINGS_INSTRUCTOR_FAILED,
  EDIT_ROOM_MEETINGS_INSTRUCTOR_SUCCEEDED,
  GET_ANNOUNCEMENT,
  GET_ANNOUNCEMENT_FAILED,
  GET_ANNOUNCEMENT_INSTRUCTOR,
  GET_ANNOUNCEMENT_INSTRUCTOR_FAILED,
  GET_ANNOUNCEMENT_INSTRUCTOR_SUCCEEDED,
  GET_ANNOUNCEMENT_SUCCEEDED,
  GET_ASSESSMENT,
  GET_ASSESSMENT_ANSWER,
  GET_ASSESSMENT_ANSWER_BY_ID,
  GET_ASSESSMENT_ANSWER_BY_ID_FAILED,
  GET_ASSESSMENT_ANSWER_BY_ID_SUCCEEDED,
  GET_ASSESSMENT_ANSWER_COMMENT,
  GET_ASSESSMENT_ANSWER_COMMENT_BY_PAGE,
  GET_ASSESSMENT_ANSWER_COMMENT_BY_PAGE_FAILED,
  GET_ASSESSMENT_ANSWER_COMMENT_BY_PAGE_SUCCEEDED,
  GET_ASSESSMENT_ANSWER_COMMENT_FAILED,
  GET_ASSESSMENT_ANSWER_COMMENT_SUCCEEDED,
  GET_ASSESSMENT_ANSWER_FAILED,
  GET_ASSESSMENT_ANSWER_SUCCEEDED,
  GET_ASSESSMENT_BY_ID,
  GET_ASSESSMENT_BY_ID_FAILED,
  GET_ASSESSMENT_BY_ID_SUCCEEDED,
  GET_ASSESSMENT_FAILED,
  GET_ASSESSMENT_QUESTION_COMMENT,
  GET_ASSESSMENT_QUESTION_COMMENT_BY_PAGE,
  GET_ASSESSMENT_QUESTION_COMMENT_BY_PAGE_FAILED,
  GET_ASSESSMENT_QUESTION_COMMENT_BY_PAGE_SUCCEEDED,
  GET_ASSESSMENT_QUESTION_COMMENT_FAILED,
  GET_ASSESSMENT_QUESTION_COMMENT_SUCCEEDED,
  GET_ASSESSMENT_SUCCEEDED,
  GET_DISCUSSION_COMMENT_REACTION_LIST,
  GET_DISCUSSION_COMMENT_REACTION_LIST_FAILED,
  GET_DISCUSSION_COMMENT_REACTION_LIST_SUCCEEDED,
  GET_DISCUSSION_COMMENT_REPLIES_REACTION_LIST,
  GET_DISCUSSION_COMMENT_REPLIES_REACTION_LIST_FAILED,
  GET_DISCUSSION_COMMENT_REPLIES_REACTION_LIST_SUCCEEDED,
  GET_DISCUSSION_REACTION_LIST,
  GET_DISCUSSION_REACTION_LIST_FAILED,
  GET_DISCUSSION_REACTION_LIST_SUCCEEDED,
  GET_MEETING_VIDEO,
  GET_MEETING_VIDEO_FAILED,
  GET_MEETING_VIDEO_SUCCEEDED,
  GET_ROOM,
  GET_ROOM_DETAIL,
  GET_ROOM_DETAIL_FAILED,
  GET_ROOM_DETAIL_SUCCEEDED,
  GET_ROOM_DISCUSSION,
  GET_ROOM_DISCUSSION_BY_PAGE,
  GET_ROOM_DISCUSSION_BY_PAGE_FAILED,
  GET_ROOM_DISCUSSION_BY_PAGE_SUCCEEDED,
  GET_ROOM_DISCUSSION_COMMENT,
  GET_ROOM_DISCUSSION_COMMENT_BY_PAGE,
  GET_ROOM_DISCUSSION_COMMENT_BY_PAGE_FAILED,
  GET_ROOM_DISCUSSION_COMMENT_BY_PAGE_SUCCEEDED,
  GET_ROOM_DISCUSSION_COMMENT_FAILED,
  GET_ROOM_DISCUSSION_COMMENT_REPLIES,
  GET_ROOM_DISCUSSION_COMMENT_REPLIES_FAILED,
  GET_ROOM_DISCUSSION_COMMENT_REPLIES_SUCCEEDED,
  GET_ROOM_DISCUSSION_COMMENT_SUCCEEDED,
  GET_ROOM_DISCUSSION_FAILED,
  GET_ROOM_DISCUSSION_SUCCEEDED,
  GET_ROOM_FAILED,
  GET_ROOM_INSTRUCTOR,
  GET_ROOM_INSTRUCTOR_BY_SLUG,
  GET_ROOM_INSTRUCTOR_BY_SLUG_FAILED,
  GET_ROOM_INSTRUCTOR_BY_SLUG_SUCCEEDED,
  GET_ROOM_INSTRUCTOR_FAILED,
  GET_ROOM_INSTRUCTOR_SUCCEEDED,
  GET_ROOM_MEETINGS,
  GET_ROOM_MEETINGS_BY_SLUG,
  GET_ROOM_MEETINGS_BY_SLUG_FAILED,
  GET_ROOM_MEETINGS_BY_SLUG_SUCCEEDED,
  GET_ROOM_MEETINGS_FAILED,
  GET_ROOM_MEETINGS_INSTRUCTOR,
  GET_ROOM_MEETINGS_INSTRUCTOR_FAILED,
  GET_ROOM_MEETINGS_INSTRUCTOR_SUCCEEDED,
  GET_ROOM_MEETINGS_SUCCEEDED,
  GET_ROOM_MEMBERS,
  GET_ROOM_MEMBERS_BY_PAGE,
  GET_ROOM_MEMBERS_BY_PAGE_FAILED,
  GET_ROOM_MEMBERS_BY_PAGE_SUCCEEDED,
  GET_ROOM_MEMBERS_FAILED,
  GET_ROOM_MEMBERS_SUCCEEDED,
  GET_ROOM_SUCCEEDED,
  INITIAL_ROOM_DISCUSSION_COMMENT_QUERY,
  INITIAL_ROOM_DISCUSSION_COMMENT_REPLIES_QUERY,
  INVITE_MEMBER_FAILED,
  INVITE_MEMBER_REQUEST,
  INVITE_MEMBER_SUCCEEDED,
  JOIN_ROOM_FAILED,
  JOIN_ROOM_REQUEST,
  JOIN_ROOM_SUCCEEDED,
  LEAVE_ROOM_FAILED,
  LEAVE_ROOM_REQUEST,
  LEAVE_ROOM_SUCCEEDED,
  LIKE_ROOM_DISCUSSION_COMMENT_REPLIES,
  LIKE_ROOM_DISCUSSION_COMMENT_REPLIES_FAILED,
  LIKE_ROOM_DISCUSSION_COMMENT_REPLIES_SUCCEEDED,
  MIGRATE_COURSE_ENROLLED_USERS,
  MIGRATE_COURSE_ENROLLED_USERS_FAILED,
  MIGRATE_COURSE_ENROLLED_USERS_SUCCEEDED,
  REJECT_TO_INVITATION_REQUEST,
  REJECT_TO_INVITATION_REQUEST_FAILED,
  REJECT_TO_INVITATION_REQUEST_SUCCEEDED,
  REMOVE_DISSCUSSION_COMMENT_OBJECT,
  REMOVE_ROOM_MEMBERS,
  REMOVE_ROOM_MEMBERS_FAILED,
  REMOVE_ROOM_MEMBERS_SUCCEEDED,
  RESPOND_GOING_TO_MEETING,
  RESPOND_GOING_TO_MEETING_FAILED,
  RESPOND_GOING_TO_MEETING_SUCCEEDED,
  RESPOND_TO_INVITATION_REQUEST,
  RESPOND_TO_INVITATION_REQUEST_FAILED,
  RESPOND_TO_INVITATION_REQUEST_SUCCEEDED,
  ROOM_DISCUSSION_LIKE,
  ROOM_DISCUSSION_LIKE_COMMENT,
  ROOM_DISCUSSION_LIKE_COMMENT_FAILED,
  ROOM_DISCUSSION_LIKE_COMMENT_SUCCEEDED,
  ROOM_DISCUSSION_LIKE_FAILED,
  ROOM_DISCUSSION_LIKE_SUCCEEDED,
  ROOM_DISCUSSION_REPORT,
  ROOM_DISCUSSION_REPORT_FAILED,
  ROOM_DISCUSSION_REPORT_SUCCEEDED,
  SET_ROOM_DATA,
  SET_ROOM_DISCUSSION_COMMENT_QUERY,
  SET_ROOM_EDIT_DATA,
  SET_ROOM_ERROR_DATA,
  SET_ROOM_MEMBER_ACTIVE_TAB,
  SET_ROOM_QUERY_DATA,
  UPDATE_ROOM_MEMBER,
  UPDATE_ROOM_MEMBER_FAILED,
  UPDATE_ROOM_MEMBER_SUCCEEDED,
  VOTE_ROOM_DISCUSSION_POLL,
  VOTE_ROOM_DISCUSSION_POLL_FAILED,
  VOTE_ROOM_DISCUSSION_POLL_SUCCEEDED,
} from '.';

// Instructor part
export const getRooms = (data = {}) => {
  let query = '';
  if (data) {
    Object.keys(data).map((each) => {
      query = `${query}&${each}=${data[each]}`;
    });
  }
  return {
    type: GET_ROOM_INSTRUCTOR,
    payload: {
      url: `room/?${query}`,
      onSuccess: GET_ROOM_INSTRUCTOR_SUCCEEDED,
      onFailure: GET_ROOM_INSTRUCTOR_FAILED,
    },
  };
};

export const getRoomBySlug = (slug) => {
  return {
    type: GET_ROOM_INSTRUCTOR_BY_SLUG,
    payload: {
      url: `room/${slug}/`,
      onSuccess: GET_ROOM_INSTRUCTOR_BY_SLUG_SUCCEEDED,
      onFailure: GET_ROOM_INSTRUCTOR_BY_SLUG_FAILED,
    },
  };
};

export const addRooms = (data = {}) => {
  return {
    type: ADD_ROOM_INSTRUCTOR,
    payload: {
      data,
      url: `room/`,
      onSuccess: ADD_ROOM_INSTRUCTOR_SUCCEEDED,
      onFailure: ADD_ROOM_INSTRUCTOR_FAILED,
    },
  };
};

export const editRooms = (data = {}, slug = {}) => {
  return {
    type: EDIT_ROOM_INSTRUCTOR,
    payload: {
      data,
      url: `room/${slug}/`,
      onSuccess: EDIT_ROOM_INSTRUCTOR_SUCCEEDED,
      onFailure: EDIT_ROOM_INSTRUCTOR_FAILED,
    },
  };
};

export const deleteRooms = (slug = {}) => {
  return {
    type: DELETE_ROOM_INSTRUCTOR,
    payload: {
      url: `room/${slug}`,
      onSuccess: DELETE_ROOM_INSTRUCTOR_SUCCEEDED,
      onFailure: DELETE_ROOM_INSTRUCTOR_FAILED,
    },
  };
};

// Frontend Room
export const getRoomsList = (data = {}) => {
  let query = '';
  if (data) {
    Object.keys(data).map((each) => {
      query = `${query}&${each}=${data[each]}`;
    });
  }
  return {
    type: GET_ROOM,
    payload: {
      url: `room-list?${query}`,
      onSuccess: GET_ROOM_SUCCEEDED,
      onFailure: GET_ROOM_FAILED,
    },
  };
};

export const getRoomDetail = (slug = {}) => {
  return {
    type: GET_ROOM_DETAIL,
    payload: {
      url: `room-list/${slug}`,
      onSuccess: GET_ROOM_DETAIL_SUCCEEDED,
      onFailure: GET_ROOM_DETAIL_FAILED,
    },
  };
};

// Announcement

// Instructor part
export const getAnnouncement = (slug, data) => {
  let query = '';
  if (data) {
    Object.keys(data).map((each) => {
      query = `${query}&${each}=${data[each]}`;
    });
  }
  return {
    type: GET_ANNOUNCEMENT_INSTRUCTOR,
    payload: {
      url: `announcement/?room=${slug}&${query}`,
      onSuccess: GET_ANNOUNCEMENT_INSTRUCTOR_SUCCEEDED,
      onFailure: GET_ANNOUNCEMENT_INSTRUCTOR_FAILED,
    },
  };
};

export const addAnnouncement = (data = {}) => {
  return {
    type: ADD_ANNOUNCEMENT_INSTRUCTOR,
    payload: {
      data,
      url: `announcement/`,
      onSuccess: ADD_ANNOUNCEMENT_INSTRUCTOR_SUCCEEDED,
      onFailure: ADD_ANNOUNCEMENT_INSTRUCTOR_FAILED,
    },
  };
};

export const editAnnouncement = (data = {}, slug = {}) => {
  return {
    type: EDIT_ANNOUNCEMENT_INSTRUCTOR,
    payload: {
      data,
      url: `announcement/${slug}/`,
      onSuccess: EDIT_ANNOUNCEMENT_INSTRUCTOR_SUCCEEDED,
      onFailure: EDIT_ANNOUNCEMENT_INSTRUCTOR_FAILED,
    },
  };
};

export const deleteAnnouncement = (slug = {}) => {
  return {
    type: DELETE_ANNOUNCEMENT_INSTRUCTOR,
    payload: {
      url: `announcement/${slug}`,
      onSuccess: DELETE_ANNOUNCEMENT_INSTRUCTOR_SUCCEEDED,
      onFailure: DELETE_ANNOUNCEMENT_INSTRUCTOR_FAILED,
    },
  };
};

// Frontend Announcement
export const getAnnouncementList = (roomSlug = {}, query) => {
  return {
    type: GET_ANNOUNCEMENT,
    payload: {
      url: `announcement-list?room=${roomSlug}&${query}`,
      onSuccess: GET_ANNOUNCEMENT_SUCCEEDED,
      onFailure: GET_ANNOUNCEMENT_FAILED,
    },
  };
};

// Room Meetings

export const getRoomMeetings = (slug = {}, data) => {
  let query = '';
  if (data) {
    Object.keys(data).map((each) => {
      query = `${query}&${each}=${data[each]}`;
    });
  }
  return {
    type: GET_ROOM_MEETINGS_INSTRUCTOR,
    payload: {
      url: `lecture?room=${slug}${query}`,
      onSuccess: GET_ROOM_MEETINGS_INSTRUCTOR_SUCCEEDED,
      onFailure: GET_ROOM_MEETINGS_INSTRUCTOR_FAILED,
    },
  };
};

export const addRoomMeetings = (data = {}) => {
  return {
    type: ADD_ROOM_MEETINGS_INSTRUCTOR,
    payload: {
      data,
      url: `lecture/`,
      onSuccess: ADD_ROOM_MEETINGS_INSTRUCTOR_SUCCEEDED,
      onFailure: ADD_ROOM_MEETINGS_INSTRUCTOR_FAILED,
    },
  };
};

export const editRoomMeetings = (data = {}, slug = {}) => {
  return {
    type: EDIT_ROOM_MEETINGS_INSTRUCTOR,
    payload: {
      data,
      url: `lecture/${slug}/`,
      onSuccess: EDIT_ROOM_MEETINGS_INSTRUCTOR_SUCCEEDED,
      onFailure: EDIT_ROOM_MEETINGS_INSTRUCTOR_FAILED,
    },
  };
};

export const deleteRoomMeetings = (slug = {}) => {
  return {
    type: DELETE_ROOM_MEETINGS_INSTRUCTOR,
    payload: {
      url: `lecture/${slug}`,
      onSuccess: DELETE_ROOM_MEETINGS_INSTRUCTOR_SUCCEEDED,
      onFailure: DELETE_ROOM_MEETINGS_INSTRUCTOR_FAILED,
    },
  };
};

export const joinRoomRequest = ({ room }) => {
  return {
    type: JOIN_ROOM_REQUEST,
    payload: {
      url: `join_room/?room=${room}`,
      onSuccess: JOIN_ROOM_SUCCEEDED,
      onFailure: JOIN_ROOM_FAILED,
    },
  };
};

export const leaveRoomRequest = ({ room }) => {
  return {
    type: LEAVE_ROOM_REQUEST,
    payload: {
      url: `leave-room/?room=${room}`,
      onSuccess: LEAVE_ROOM_SUCCEEDED,
      onFailure: LEAVE_ROOM_FAILED,
    },
  };
};

// Meetings List Frontend

export const getRoomMeetingsLanding = (slug, data) => {
  let query = '';
  if (data) {
    Object.keys(data).map((each) => {
      query = `${query}&${each}=${data[each]}`;
    });
  }
  return {
    type: GET_ROOM_MEETINGS,
    payload: {
      url: `lecture-list?room=${slug}${query}`,
      onSuccess: GET_ROOM_MEETINGS_SUCCEEDED,
      onFailure: GET_ROOM_MEETINGS_FAILED,
    },
  };
};

export const getRoomMeetingSlug = (slug = {}) => {
  return {
    type: GET_ROOM_MEETINGS_BY_SLUG,
    payload: {
      url: `lecture-list/${slug}`,
      onSuccess: GET_ROOM_MEETINGS_BY_SLUG_SUCCEEDED,
      onFailure: GET_ROOM_MEETINGS_BY_SLUG_FAILED,
    },
  };
};

export const respondGoingToMeeting = ({ meeting }) => {
  return {
    type: RESPOND_GOING_TO_MEETING,
    payload: {
      url: `attend_meeting/?lecture=${meeting}`,
      onSuccess: RESPOND_GOING_TO_MEETING_SUCCEEDED,
      onFailure: RESPOND_GOING_TO_MEETING_FAILED,
    },
  };
};

export const getMeetingVideo = (slug = {}) => {
  return {
    type: GET_MEETING_VIDEO,
    payload: {
      url: `lecture-video-list?${slug}`,
      onSuccess: GET_MEETING_VIDEO_SUCCEEDED,
      onFailure: GET_MEETING_VIDEO_FAILED,
    },
  };
};

export const addMeetingVideo = (data = {}) => {
  return {
    type: ADD_MEETING_VIDEO,
    payload: {
      data,
      url: `lecture-video/`,
      onSuccess: ADD_MEETING_VIDEO_SUCCEEDED,
      onFailure: ADD_MEETING_VIDEO_FAILED,
    },
  };
};

// Room Discussions
export const getRoomDiscussion = ({ data }) => {
  const query = getCustomQueries(data);
  return {
    type: GET_ROOM_DISCUSSION,
    payload: {
      url: `room-discussions?${query}`,
      onSuccess: GET_ROOM_DISCUSSION_SUCCEEDED,
      onFailure: GET_ROOM_DISCUSSION_FAILED,
    },
  };
};

export const getDiscussionsByPage = ({ data }) => {
  const query = getCustomQueries(data);
  return {
    type: GET_ROOM_DISCUSSION_BY_PAGE,
    payload: {
      url: `room-discussions?${query}`,
      onSuccess: GET_ROOM_DISCUSSION_BY_PAGE_SUCCEEDED,
      onFailure: GET_ROOM_DISCUSSION_BY_PAGE_FAILED,
    },
  };
};

export const addRoomDiscussion = ({ data }) => {
  return {
    type: ADD_ROOM_DISCUSSION,
    payload: {
      data,
      url: `room-discussions/`,
      onSuccess: ADD_ROOM_DISCUSSION_SUCCEEDED,
      onFailure: ADD_ROOM_DISCUSSION_FAILED,
    },
  };
};

export const likeDiscussion = ({ discussionId }) => {
  return {
    type: ROOM_DISCUSSION_LIKE,
    payload: {
      url: `discussion-like/?doubt=${discussionId}`,
      onSuccess: ROOM_DISCUSSION_LIKE_SUCCEEDED,
      onFailure: ROOM_DISCUSSION_LIKE_FAILED,
    },
  };
};

export const reactDiscussion = ({ data }) => {
  return {
    type: ROOM_DISCUSSION_LIKE,
    payload: {
      data,
      url: `discussion-react/`,
      onSuccess: ROOM_DISCUSSION_LIKE_SUCCEEDED,
      onFailure: ROOM_DISCUSSION_LIKE_FAILED,
    },
  };
};

export const getDiscussionPostReactionList = ({ reaction, discussionId }) => {
  return {
    type: GET_DISCUSSION_REACTION_LIST,
    payload: {
      url: `discussion-reacts/${discussionId}/?reaction=${reaction}`,
      onSuccess: GET_DISCUSSION_REACTION_LIST_SUCCEEDED,
      onFailure: GET_DISCUSSION_REACTION_LIST_FAILED,
    },
  };
};

export const reportDiscussion = ({ data }) => {
  return {
    type: ROOM_DISCUSSION_REPORT,
    payload: {
      data,
      url: `report-doubt/`,
      onSuccess: ROOM_DISCUSSION_REPORT_SUCCEEDED,
      onFailure: ROOM_DISCUSSION_REPORT_FAILED,
    },
  };
};

export const editRoomDiscussion = ({ data, discussionId }) => {
  return {
    type: EDIT_ROOM_DISCUSSION,
    payload: {
      data,
      url: `room-discussions/${discussionId}/`,
      onSuccess: EDIT_ROOM_DISCUSSION_SUCCEEDED,
      onFailure: EDIT_ROOM_DISCUSSION_FAILED,
    },
  };
};

export const deleteRoomDiscussion = ({ discussionId }) => {
  return {
    type: DELETE_ROOM_DISCUSSION,
    payload: {
      url: `room-discussions/${discussionId}/`,
      onSuccess: DELETE_ROOM_DISCUSSION_SUCCEEDED,
      onFailure: DELETE_ROOM_DISCUSSION_FAILED,
    },
  };
};

// Room Discussion Polls
export const voteRoomDiscussionPoll = ({ answerId }) => {
  return {
    type: VOTE_ROOM_DISCUSSION_POLL,
    payload: {
      url: `poll-vote/?id=${answerId}`,
      onSuccess: VOTE_ROOM_DISCUSSION_POLL_SUCCEEDED,
      onFailure: VOTE_ROOM_DISCUSSION_POLL_FAILED,
    },
  };
};

// Room Discussion Comments
export const getDiscussionComments = ({ data }) => {
  const query = getCustomQueries(data);
  return {
    type: GET_ROOM_DISCUSSION_COMMENT,
    payload: {
      url: `room-discussions-comments/?${query}`,
      onSuccess: GET_ROOM_DISCUSSION_COMMENT_SUCCEEDED,
      onFailure: GET_ROOM_DISCUSSION_COMMENT_FAILED,
    },
  };
};

// Room Discussion Comments Replies
export const getDiscussionCommentReplies = ({ data }) => {
  const query = getCustomQueries(data);
  return {
    type: GET_ROOM_DISCUSSION_COMMENT_REPLIES,
    payload: {
      url: `room-discussions-comment-reply/?${query}`,
      onSuccess: GET_ROOM_DISCUSSION_COMMENT_REPLIES_SUCCEEDED,
      onFailure: GET_ROOM_DISCUSSION_COMMENT_REPLIES_FAILED,
    },
  };
};

export const addDiscussionCommentReplies = ({ data }) => {
  return {
    type: ADD_ROOM_DISCUSSION_COMMENT_REPLIES,
    payload: {
      data,
      url: `room-discussions-comment-reply/`,
      onSuccess: ADD_ROOM_DISCUSSION_COMMENT_REPLIES_SUCCEEDED,
      onFailure: ADD_ROOM_DISCUSSION_COMMENT_REPLIES_FAILED,
    },
  };
};

export const likeDiscussionCommentReplies = ({ data }) => {
  return {
    type: LIKE_ROOM_DISCUSSION_COMMENT_REPLIES,
    payload: {
      data,
      url: `discussion-comments-like-reply/`,
      onSuccess: LIKE_ROOM_DISCUSSION_COMMENT_REPLIES_SUCCEEDED,
      onFailure: LIKE_ROOM_DISCUSSION_COMMENT_REPLIES_FAILED,
    },
  };
};

export const reactDiscussionCommentReplies = ({ data }) => {
  return {
    type: LIKE_ROOM_DISCUSSION_COMMENT_REPLIES,
    payload: {
      data,
      url: `discussion-comment-reply-react/`,
      onSuccess: LIKE_ROOM_DISCUSSION_COMMENT_REPLIES_SUCCEEDED,
      onFailure: LIKE_ROOM_DISCUSSION_COMMENT_REPLIES_FAILED,
    },
  };
};

export const getRepliesReactionList = ({ reaction, replyId }) => {
  return {
    type: GET_DISCUSSION_COMMENT_REPLIES_REACTION_LIST,
    payload: {
      url: `discussion-comment-reply-reacts/${replyId}/?reaction=${reaction}`,
      onSuccess: GET_DISCUSSION_COMMENT_REPLIES_REACTION_LIST_SUCCEEDED,
      onFailure: GET_DISCUSSION_COMMENT_REPLIES_REACTION_LIST_FAILED,
    },
  };
};

export const deleteDiscussionCommentReplies = ({ replyId }) => {
  return {
    type: DELETE_ROOM_DISCUSSION_COMMENT_REPLIES,
    payload: {
      url: `room-discussions-comment-reply/${replyId}/`,
      onSuccess: DELETE_ROOM_DISCUSSION_COMMENT_REPLIES_SUCCEEDED,
      onFailure: DELETE_ROOM_DISCUSSION_COMMENT_REPLIES_FAILED,
    },
  };
};

export const editDiscussionCommentsReplies = ({ data, replyId }) => {
  return {
    type: EDIT_ROOM_DISCUSSION_COMMENT_REPLIES,
    payload: {
      data,
      url: `room-discussions-comment-reply/${replyId}/`,
      onSuccess: EDIT_ROOM_DISCUSSION_COMMENT_REPLIES_SUCCEEDED,
      onFailure: EDIT_ROOM_DISCUSSION_COMMENT_REPLIES_FAILED,
    },
  };
};

export const initialRoomDisscussionCommentReplyQuery = ({ payload }) => {
  return {
    type: INITIAL_ROOM_DISCUSSION_COMMENT_REPLIES_QUERY,
    payload,
  };
};

export const clearCommentReplyData = () => {
  return {
    type: CLEAR_COMMENT_REPLY_DATA,
  };
};

export const getDiscussionCommentsByPage = ({ data }) => {
  const query = getCustomQueries(data);
  return {
    type: GET_ROOM_DISCUSSION_COMMENT_BY_PAGE,
    payload: {
      url: `doubt-comments/?${query}`,
      onSuccess: GET_ROOM_DISCUSSION_COMMENT_BY_PAGE_SUCCEEDED,
      onFailure: GET_ROOM_DISCUSSION_COMMENT_BY_PAGE_FAILED,
    },
  };
};
export const setRoomDisscussionCommentQuery = ({ payload }) => {
  return {
    type: SET_ROOM_DISCUSSION_COMMENT_QUERY,
    payload,
  };
};
export const initialRoomDisscussionCommentQuery = ({ payload }) => {
  return {
    type: INITIAL_ROOM_DISCUSSION_COMMENT_QUERY,
    payload,
  };
};

export const addDiscussionComments = ({ data }) => {
  return {
    type: ADD_ROOM_DISCUSSION_COMMENT,
    payload: {
      data,
      url: `room-discussions-comments/`,
      onSuccess: ADD_ROOM_DISCUSSION_COMMENT_SUCCEEDED,
      onFailure: ADD_ROOM_DISCUSSION_COMMENT_FAILED,
    },
  };
};

export const likeDiscussionComment = ({ data }) => {
  return {
    type: ROOM_DISCUSSION_LIKE_COMMENT,
    payload: {
      data,
      url: `discussion-comments-like/`,
      onSuccess: ROOM_DISCUSSION_LIKE_COMMENT_SUCCEEDED,
      onFailure: ROOM_DISCUSSION_LIKE_COMMENT_FAILED,
    },
  };
};

export const reactDiscussionComment = ({ data }) => {
  return {
    type: ROOM_DISCUSSION_LIKE_COMMENT,
    payload: {
      data,
      url: `discussion-comment-react/`,
      onSuccess: ROOM_DISCUSSION_LIKE_COMMENT_SUCCEEDED,
      onFailure: ROOM_DISCUSSION_LIKE_COMMENT_FAILED,
    },
  };
};

export const getCommentsReactionList = ({ reaction, commentId }) => {
  return {
    type: GET_DISCUSSION_COMMENT_REACTION_LIST,
    payload: {
      url: `discussion-comment-reacts/${commentId}/?reaction=${reaction}`,
      onSuccess: GET_DISCUSSION_COMMENT_REACTION_LIST_SUCCEEDED,
      onFailure: GET_DISCUSSION_COMMENT_REACTION_LIST_FAILED,
    },
  };
};

export const deleteDiscussionComment = ({ commentId }) => {
  return {
    type: DELETE_ROOM_DISCUSSION_COMMENT,
    payload: {
      url: `room-discussions-comments/${commentId}`,
      onSuccess: DELETE_ROOM_DISCUSSION_COMMENT_SUCCEEDED,
      onFailure: DELETE_ROOM_DISCUSSION_COMMENT_FAILED,
    },
  };
};

export const editDiscussionComments = ({ data, commentId }) => {
  return {
    type: EDIT_ROOM_DISCUSSION_COMMENT,
    payload: {
      data,
      url: `room-discussions-comments/${commentId}/`,
      onSuccess: EDIT_ROOM_DISCUSSION_COMMENT_SUCCEEDED,
      onFailure: EDIT_ROOM_DISCUSSION_COMMENT_FAILED,
    },
  };
};

export const removeDiscussionCommentObject = ({ id }) => {
  return {
    type: REMOVE_DISSCUSSION_COMMENT_OBJECT,
    payload: id,
  };
};

export const getRoomMembers = ({ data }) => {
  let query = getCustomQueries(data);
  return {
    type: GET_ROOM_MEMBERS,
    payload: {
      url: `room-members?${query}`,
      onSuccess: GET_ROOM_MEMBERS_SUCCEEDED,
      onFailure: GET_ROOM_MEMBERS_FAILED,
    },
  };
};

export const updateRoomMember = ({ memberId, data }) => {
  return {
    type: UPDATE_ROOM_MEMBER,
    payload: {
      data,
      url: `room-members/${memberId}/`,
      onSuccess: UPDATE_ROOM_MEMBER_SUCCEEDED,
      onFailure: UPDATE_ROOM_MEMBER_FAILED,
    },
  };
};

export const getRoomMembersByPage = (page = {}, roomSlug = {}) => {
  return {
    type: GET_ROOM_MEMBERS_BY_PAGE,
    payload: {
      url: `room-members?page=${page}&room=${roomSlug}`,
      onSuccess: GET_ROOM_MEMBERS_BY_PAGE_SUCCEEDED,
      onFailure: GET_ROOM_MEMBERS_BY_PAGE_FAILED,
    },
  };
};

// Remove Room Member
export const removeRoomMember = (user, roomSlug) => {
  return {
    type: REMOVE_ROOM_MEMBERS,
    payload: {
      url: `remove-members/?room=${roomSlug}&user=${user}`,
      onSuccess: REMOVE_ROOM_MEMBERS_SUCCEEDED,
      onFailure: REMOVE_ROOM_MEMBERS_FAILED,
    },
  };
};

export const inviteMemberRequest = ({ data }) => {
  return {
    type: INVITE_MEMBER_REQUEST,
    payload: {
      data,
      url: `invite-users/`,
      onSuccess: INVITE_MEMBER_SUCCEEDED,
      onFailure: INVITE_MEMBER_FAILED,
    },
  };
};

export const respondRoomInviteRequest = ({ data }) => {
  return {
    type:
      data?.status === 1
        ? RESPOND_TO_INVITATION_REQUEST
        : REJECT_TO_INVITATION_REQUEST,
    payload: {
      data,
      url: `respond-invite/`,
      onSuccess:
        data?.status === 1
          ? RESPOND_TO_INVITATION_REQUEST_SUCCEEDED
          : REJECT_TO_INVITATION_REQUEST_SUCCEEDED,
      onFailure:
        data?.status === 1
          ? RESPOND_TO_INVITATION_REQUEST_FAILED
          : REJECT_TO_INVITATION_REQUEST_FAILED,
    },
  };
};

export const migrateCourseUsersRequest = ({ data }) => {
  return {
    type: MIGRATE_COURSE_ENROLLED_USERS,
    payload: {
      data,
      url: `migrate-enrolled-users/`,
      onSuccess: MIGRATE_COURSE_ENROLLED_USERS_SUCCEEDED,
      onFailure: MIGRATE_COURSE_ENROLLED_USERS_FAILED,
    },
  };
};

// Assessment
export const getAssessment = (slug, data) => {
  let query = '';
  if (data) {
    Object.keys(data).map((each) => {
      query = `${query}&${each}=${data[each]}`;
    });
  }
  return {
    type: GET_ASSESSMENT,
    payload: {
      url: `assessment-question/?room=${slug}&${query}`,
      onSuccess: GET_ASSESSMENT_SUCCEEDED,
      onFailure: GET_ASSESSMENT_FAILED,
    },
  };
};

export const getAssessmentById = (id = {}) => {
  return {
    type: GET_ASSESSMENT_BY_ID,
    payload: {
      url: `assessment-question/${id}`,
      onSuccess: GET_ASSESSMENT_BY_ID_SUCCEEDED,
      onFailure: GET_ASSESSMENT_BY_ID_FAILED,
    },
  };
};

export const addAssessment = (data = {}) => {
  return {
    type: ADD_ASSESSMENT,
    payload: {
      data,
      url: `assessment-question/`,
      onSuccess: ADD_ASSESSMENT_SUCCEEDED,
      onFailure: ADD_ASSESSMENT_FAILED,
    },
  };
};

export const editAssessment = (data = {}, slug = {}) => {
  return {
    type: EDIT_ASSESSMENT,
    payload: {
      data,
      url: `assessment-question/${slug}/`,
      onSuccess: EDIT_ASSESSMENT_SUCCEEDED,
      onFailure: EDIT_ASSESSMENT_FAILED,
    },
  };
};

export const deleteAssessment = (slug = {}) => {
  return {
    type: DELETE_ASSESSMENT,
    payload: {
      url: `assessment-question/${slug}`,
      onSuccess: DELETE_ASSESSMENT_SUCCEEDED,
      onFailure: DELETE_ASSESSMENT_FAILED,
    },
  };
};
export const getAssessmentAnswers = (id, data) => {
  let query = '';
  if (data) {
    Object.keys(data).map((each) => {
      query = `${query}&${each}=${data[each]}`;
    });
  }
  return {
    type: GET_ASSESSMENT_ANSWER,
    payload: {
      url: `assessment-answer/?question=${id}&${query}`,
      onSuccess: GET_ASSESSMENT_ANSWER_SUCCEEDED,
      onFailure: GET_ASSESSMENT_ANSWER_FAILED,
    },
  };
};

export const getAssessmentAnswerById = (id = {}) => {
  return {
    type: GET_ASSESSMENT_ANSWER_BY_ID,
    payload: {
      url: `assessment-answer/${id}`,
      onSuccess: GET_ASSESSMENT_ANSWER_BY_ID_SUCCEEDED,
      onFailure: GET_ASSESSMENT_ANSWER_BY_ID_FAILED,
    },
  };
};

export const addAssessmentAnswer = (data = {}) => {
  return {
    type: ADD_ASSESSMENT_ANSWER,
    payload: {
      data,
      url: `assessment-answer/`,
      onSuccess: ADD_ASSESSMENT_ANSWER_SUCCEEDED,
      onFailure: ADD_ASSESSMENT_ANSWER_FAILED,
    },
  };
};

export const editAssessmentAnswer = (data = {}, slug = {}) => {
  return {
    type: EDIT_ASSESSMENT_ANSWER,
    payload: {
      data,
      url: `assessment-answer/${slug}/`,
      onSuccess: EDIT_ASSESSMENT_ANSWER_SUCCEEDED,
      onFailure: EDIT_ASSESSMENT_ANSWER_FAILED,
    },
  };
};

export const deleteAssessmentAnswer = (slug = {}) => {
  return {
    type: DELETE_ASSESSMENT_ANSWER,
    payload: {
      url: `assessment-answer/${slug}`,
      onSuccess: DELETE_ASSESSMENT_ANSWER_SUCCEEDED,
      onFailure: DELETE_ASSESSMENT_ANSWER_FAILED,
    },
  };
};

// Assessment Question
export const getAssessmentQuestionComment = (question = {}, data = {}) => {
  let query = getCustomQueries(data);
  return {
    type: GET_ASSESSMENT_QUESTION_COMMENT,
    payload: {
      url: `assessment-feedback/?question=${question}&${query}`,
      onSuccess: GET_ASSESSMENT_QUESTION_COMMENT_SUCCEEDED,
      onFailure: GET_ASSESSMENT_QUESTION_COMMENT_FAILED,
    },
  };
};

export const getAssessmentQuestionCommentsByPage = (question = {}, data = {}) => {
  const query = getCustomQueries(data);
  return {
    type: GET_ASSESSMENT_QUESTION_COMMENT_BY_PAGE,
    payload: {
      url: `assessment-feedback/?question=${question}&${query}`,
      onSuccess: GET_ASSESSMENT_QUESTION_COMMENT_BY_PAGE_SUCCEEDED,
      onFailure: GET_ASSESSMENT_QUESTION_COMMENT_BY_PAGE_FAILED,
    },
  };
};

// export const getAssessmentFeedbackById = (id = {}) => {
//   return {
//     type: GET_ASSESSMENT_FEEDBACK_BY_ID,
//     payload: {
//       url: `assessment-feedback/${id}`,
//       onSuccess: GET_ASSESSMENT_FEEDBACK_BY_ID_SUCCEEDED,
//       onFailure: GET_ASSESSMENT_FEEDBACK_BY_ID_FAILED,
//     },
//   };
// };

export const addAssessmentQuestionComment = (data = {}) => {
  return {
    type: ADD_ASSESSMENT_QUESTION_COMMENT,
    payload: {
      data,
      url: `assessment-feedback/`,
      onSuccess: ADD_ASSESSMENT_QUESTION_COMMENT_SUCCEEDED,
      onFailure: ADD_ASSESSMENT_QUESTION_COMMENT_FAILED,
    },
  };
};

export const editAssessmentQuestionComment = (data = {}, id = {}) => {
  return {
    type: EDIT_ASSESSMENT_QUESTION_COMMENT,
    payload: {
      data,
      url: `assessment-feedback/${id}/`,
      onSuccess: EDIT_ASSESSMENT_QUESTION_COMMENT_SUCCEEDED,
      onFailure: EDIT_ASSESSMENT_QUESTION_COMMENT_FAILED,
    },
  };
};

export const deleteAssessmentQuestionComment = (id = {}) => {
  return {
    type: DELETE_ASSESSMENT_QUESTION_COMMENT,
    payload: {
      url: `assessment-feedback/${id}`,
      onSuccess: DELETE_ASSESSMENT_QUESTION_COMMENT_SUCCEEDED,
      onFailure: DELETE_ASSESSMENT_QUESTION_COMMENT_FAILED,
    },
  };
};

// Assessment Answer

// Assessment Question
export const getAssessmentAnswerComment = (answer = {}, data) => {
  let query = getCustomQueries(data);
  return {
    type: GET_ASSESSMENT_ANSWER_COMMENT,
    payload: {
      url: `assessment-feedback/?answer=${answer}&${query}`,
      onSuccess: GET_ASSESSMENT_ANSWER_COMMENT_SUCCEEDED,
      onFailure: GET_ASSESSMENT_ANSWER_COMMENT_FAILED,
    },
  };
};

export const getAssessmentAnswerCommentsByPage = (answer = {}, data = {}) => {
  const query = getCustomQueries(data);
  return {
    type: GET_ASSESSMENT_ANSWER_COMMENT_BY_PAGE,
    payload: {
      url: `assessment-feedback/?answer=${answer}&${query}`,
      onSuccess: GET_ASSESSMENT_ANSWER_COMMENT_BY_PAGE_SUCCEEDED,
      onFailure: GET_ASSESSMENT_ANSWER_COMMENT_BY_PAGE_FAILED,
    },
  };
};

export const addAssessmentAnswerComment = (data = {}) => {
  return {
    type: ADD_ASSESSMENT_ANSWER_COMMENT,
    payload: {
      data,
      url: `assessment-feedback/`,
      onSuccess: ADD_ASSESSMENT_ANSWER_COMMENT_SUCCEEDED,
      onFailure: ADD_ASSESSMENT_ANSWER_COMMENT_FAILED,
    },
  };
};

export const editAssessmentAnswerComment = (data = {}, id = {}) => {
  return {
    type: EDIT_ASSESSMENT_ANSWER_COMMENT,
    payload: {
      data,
      url: `assessment-feedback/${id}/`,
      onSuccess: EDIT_ASSESSMENT_ANSWER_COMMENT_SUCCEEDED,
      onFailure: EDIT_ASSESSMENT_ANSWER_COMMENT_FAILED,
    },
  };
};

export const deleteAssessmentAnswerComment = (id = {}) => {
  return {
    type: DELETE_ASSESSMENT_ANSWER_COMMENT,
    payload: {
      url: `assessment-feedback/${id}`,
      onSuccess: DELETE_ASSESSMENT_ANSWER_COMMENT_SUCCEEDED,
      onFailure: DELETE_ASSESSMENT_ANSWER_COMMENT_FAILED,
    },
  };
};

export const setRoomEditData = (payload) => {
  return {
    type: SET_ROOM_EDIT_DATA,
    payload,
  };
};

export const setRoomQueryData = (payload) => {
  return {
    type: SET_ROOM_QUERY_DATA,
    payload,
  };
};

export const setRoomData = (payload) => {
  return {
    type: SET_ROOM_DATA,
    payload,
  };
};

export const setMemberActiveTab = (value) => {
  return {
    type: SET_ROOM_MEMBER_ACTIVE_TAB,
    payload: {
      value,
    },
  };
};

export const clearRoomError = () => {
  return {
    type: CLEAR_ROOM_ERROR,
  };
};

export const clearRoomQuery = () => {
  return {
    type: CLEAR_ROOM_QUERY,
  };
};

export const clearRoomData = () => {
  return {
    type: CLEAR_ROOM_DATA,
  };
};

export const clearRoomDataToInitial = () => {
  return {
    type: CLEAR_ROOM_DATA_TO_INITIAL,
  };
};

export const commentDiscussionData = () => {
  return {
    type: CLEAR_COMMENT_DISCCUSION_DATA,
  };
};

export const setRoomErrorData = (data = {}) => {
  return {
    type: SET_ROOM_ERROR_DATA,
    payload: {
      data,
    },
  };
};
